module.exports = __webpack_public_path__ + "img/elecciones18022026.8d591355.jpg";